import moment from 'moment'

export default (value) => moment(value).utc().format()